/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClipsRecordingPreferenceBody
 */
export interface UpdateClipsRecordingPreferenceBody {
    /**
     * Whether the clip pipeline should emit CLIP_FIRE for this user
     * @type {boolean}
     * @memberof UpdateClipsRecordingPreferenceBody
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the UpdateClipsRecordingPreferenceBody interface.
 */
export function instanceOfUpdateClipsRecordingPreferenceBody(value: object): value is UpdateClipsRecordingPreferenceBody {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UpdateClipsRecordingPreferenceBodyFromJSON(json: any): UpdateClipsRecordingPreferenceBody {
    return UpdateClipsRecordingPreferenceBodyFromJSONTyped(json, false);
}

export function UpdateClipsRecordingPreferenceBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClipsRecordingPreferenceBody {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function UpdateClipsRecordingPreferenceBodyToJSON(json: any): UpdateClipsRecordingPreferenceBody {
    return UpdateClipsRecordingPreferenceBodyToJSONTyped(json, false);
}

export function UpdateClipsRecordingPreferenceBodyToJSONTyped(value?: UpdateClipsRecordingPreferenceBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

